import React, { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Modal } from "./ui/modal/modal";
import { Button } from "./ui/button";

export const usePristineInvalidAlert = (_isDirty: () => boolean) => {
  const [exitUrl, _setExitUrl] = useState<number | URL | undefined>(undefined);
  const [show, setShow] = useState(false);
  const [discardChanges, setDiscardChanges] = useState(false);
  const nav = useNavigate();

  // TODO: usePreventNavigate does not exist in TanStack Router - need to implement navigation prevention using beforeLoad or other router hooks
  /*
  usePreventNavigate(async (url) => {
    if (!discardChanges && (await isDirty()) && !show) {
      if (url) {
        setExitUrl(url);
        setShow(true);
      }

      return true;
    }

    setShow(false);
    setDiscardChanges(false);
    return false;
  });
  */

  const onDiscard = async () => {
    setShow(false);
    setDiscardChanges(true);

    if (exitUrl && "string" === typeof exitUrl) {
      await nav({ to: exitUrl });
    }
  };

  const onKeepEditing = () => {
    setShow(false);
  };

  return { show, discardChanges, exitUrl, onDiscard, setShow, onKeepEditing };
};

export const PristineInvalidAlert = ({
  show,
  onDiscard,
  onKeepEditing,
}: {
  onDiscard: () => void;
  onKeepEditing: () => void;
  show: boolean;
}) => {
  return (
    <Modal.Root open={show}>
      <Modal.Panel>
        <Modal.Title>You haven&rsquo;t completed this form yet.</Modal.Title>
        <Modal.Description>
          You haven&rsquo;t completed this form yet. Please keep editing and
          make sure to fill out all required fields.
        </Modal.Description>
        <footer className="flex items-center justify-end gap-4">
          <Button variant="ghost" onClick={onKeepEditing}>
            Keep Editing
          </Button>
          <Button variant="destructive" onClick={onDiscard}>
            Exit
          </Button>
        </footer>
      </Modal.Panel>
    </Modal.Root>
  );
};
